import { Box } from '@mui/material';
import * as React from 'react';
import { FC } from 'react';
import CircularProgress from '@mui/material/CircularProgress';

type Props = {
    isVisible: boolean;
    height?: number;
};

const UILoader: FC<Props> = ({ isVisible, height = 300 }) => {
    if (!isVisible) return null;

    return (
        <Box sx={{ display: 'flex', height, alignItems: 'center', justifyContent: 'center' }}>
            <CircularProgress />
        </Box>
    );
};

export { UILoader };
